// src/components/CreateBook.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import AppHeader from "./AppHeader";

const CreateBook = () => {
  const [authorName, setAuthorName] = useState("");
  const [bookTitle, setBookTitle] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const user = auth.currentUser;

  useEffect(() => {
    // if user is already logged in, load existing book data if it exists
    const fetchBook = async () => {
      if (user) {
        const bookRef = doc(db, "books", user.uid);
        const bookSnap = await getDoc(bookRef);
        if (bookSnap.exists()) {
          const data = bookSnap.data();
          setAuthorName(data.authorName || "");
          setBookTitle(data.bookTitle || "");
        }
      }
    };
    fetchBook();
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const bookRef = doc(db, "books", user.uid);
      await updateDoc(bookRef, {
        authorName,
        bookTitle
      });
      navigate("/manage-book");
    } catch (err) {
      setError("Error saving book info: " + err.message);
    }
  };

  if (!user) return <div className="container mt-5">Loading...</div>;

  return (
    <div className="container mt-5" style={{ maxWidth: 500 }}>
    <AppHeader />
      <h2 className="mb-4 text-center">Create Your Book</h2>
      {error && <div className="alert alert-danger">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Author Name</label>
          <input
            type="text"
            className="form-control"
            value={authorName}
            onChange={(e) => setAuthorName(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label>Book Title</label>
          <input
            type="text"
            className="form-control"
            value={bookTitle}
            onChange={(e) => setBookTitle(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="btn btn-success w-100">
          Save and Continue
        </button>
      </form>
    </div>
  );
};

export default CreateBook;
